/**
 * Request utilities
 */

/**
 * Check if an error is a cancelled/aborted request.
 * Handles both native fetch AbortError and axios CanceledError.
 */
export function isRequestCancelled(error: unknown): boolean {
  if (error instanceof Error) {
    // Native fetch throws AbortError
    // Axios 1.x throws CanceledError
    return error.name === 'AbortError' || error.name === 'CanceledError';
  }
  return false;
}
